<template>
  <div class="page-footer" :style="{ textAlign: footerAlign }">
    
  &copy;2026 <a rel="me" href="mailto:adelheid.harding@outlook.com">Heidi Harding</a>. Created with Vue.
  </div>
</template>

<script>
export default {
  name: "page-footer",
  props: ["footerAlign"]
}
</script>

<style scoped>
  .page-footer {
    font-size: x-small;
  }
</style>
